module.exports = __webpack_public_path__ + "static/media/javitott_meglevo_szamlak4.da1523f0.jpg";